<template>
    <li class="nav-item dropdown">
        <a id="notifications" class="nav-link d-flex align-items-center justify-center" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">

            <span v-if="unreadNotificationsCount > 0" class="ball-icon-notification">
                &nbsp;
            </span>

            <svg v-if="unreadNotificationsCount > 0" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="24" height="24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0M3.124 7.5A8.969 8.969 0 015.292 3m13.416 0a8.969 8.969 0 012.168 4.5" />
            </svg>

            <svg v-else xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" width="24" height="24">
                <path stroke-linecap="round" stroke-linejoin="round" d="M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0" />
            </svg>
        </a>

        <div class="dropdown-menu dropdown-menu-right shadow notification-dropdown" aria-labelledby="notifications">
            <div class="clear-notifications d-flex justify-content-between">
                <div class="notification-title d-none d-sm-block">
                    Notificações
                </div>

                <!-- Clear Notifications -->
                <a v-if="notifications.length > 0" href="javascript:void(0)" class="text-primary" @click="clearAllNotifications">
                    <small>Marcar como Lidas</small>
                </a>
            </div>
            <!-- Empty Notifications -->
            <div v-if="notifications.length === 0" class="dropdown-item notification-item py-2 text-sm text-muted text-wrap">
                Sem notificações.
            </div>
            <div class="notification-overflow">
                <div v-for="notification in notifications" :key="notification.id" class="dropdown-item notification-item py-2" :class="{'no-read': !notification.read_at}">
                    <div class="notification">
                        <div class="notification-title">
                            {{ notification.data.subject ?? '' }}
                        </div>
                        <div class="text-muted small">
                            {{ notification.created_at | moment('DD/MM/YYYY HH:mm') }}
                        </div>
                        <div class="notification-message text-wrap">
                            {{ notification.data.message ?? '' }}
                        </div>
                    </div>
                    <div class="d-flex justify-content-between">
                        <!-- Link -->
                        <a v-if="notification.data.link" :href="notification.data.link" class="text-primary">
                            <small>
                                {{ notification.data.label ?? 'Visualizar'}}
                            </small>
                        </a>

                        <!-- Mark as Read -->
                        <a v-if="!notification.read_at" href="javascript:void(0)" class="text-primary" @click="markAsRead(notification.id)">
                            <small>Marcar como Lida</small>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            unreadNotificationsCount: 0,
            notifications: [],
        }
    },
    created() {
        this.getAllNotifications();
    },
    methods: {

        async getAllNotifications() {
            this.loading = true;

            await axios
                .get('/teacher/notifications')
                .then(response => {
                    let result = response.data.data;

                    this.notifications = result.notifications;
                    this.unreadNotificationsCount = result.unreadNotificationsCount;
                })
                .finally(() => this.loading = false);
        },

        async clearAllNotifications() {
            this.loading = true;

            await axios
                .put('/teacher/notifications/mark-all-as-read')
                .then(async response => {
                    this.unreadNotificationsCount = 0;
                    await this.getAllNotifications();
                })
                .finally(() => this.loading = false);
        },

        async markAsRead(notificationId) {
            this.loading = true;

            await axios
                .put(`/teacher/notifications/${notificationId}/mark-as-read`)
                .then(async response => {
                    this.unreadNotificationsCount--;
                    await this.getAllNotifications();
                })
                .finally(() => this.loading = false);
        },
    }
}
</script>

<style scoped>
    .badge-notification {
        position: absolute;
        top: 3px;
        right: -3px;
        font-size: 0.6rem;
        padding: 0.2rem 0.3rem;
        border-radius: 50%;
    }
    .notification {
        word-break: break-all;
    }
    .notification-title {
        font-weight: bold;
    }
    .notification-message {
        font-size: 0.8rem;
    }
    .clear-notifications {
        margin-top: -0.5rem;
        padding: 0.5rem 1.5rem;
        border-bottom: 1px solid #e3e3e3;
    }
    .notification-item {
        border-bottom: 1px solid #e3e3e3;
    }
    .notification-item:hover {
        background-color: #e3e3e3;
    }
    .no-read {
        background-color: #F5F5F5;
    }
    .notification-overflow {
        max-height: 300px;
        overflow-y: auto;
    }
</style>
